export default __webpack_public_path__ + "static/media/tpc_clock.a28ec0d4.svg";